module.exports = __webpack_public_path__ + "img/japan.948a265f.png";